export default __webpack_public_path__ + "static/media/dashboard.c40c70ce.svg";